import { render, staticRenderFns } from "./assignement.vue?vue&type=template&id=65a46352&scoped=true&"
import script from "./assignement.vue?vue&type=script&lang=js&"
export * from "./assignement.vue?vue&type=script&lang=js&"
import style0 from "./assignement.vue?vue&type=style&index=0&id=65a46352&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a46352",
  null
  
)

export default component.exports